import JSX from "./../../helpers/react.js";
import RefObject = JSX.RefObject;
import { readNumberAttr } from "../../messages/helpers.js";


export function CustomSelectElement(props: {
    values: string[],
    className: string[] | string
}) {
    const values = props.values;
    const className = props.className;
    const customSelectElementClickHandler = (e: MouseEvent & {
        target: HTMLElement
    }) => {
        const targetEl = $(e.target);
        const currentEl = $(e.currentTarget as HTMLElement)

        currentEl.toggleClass("ss-open");

        currentEl.find(".ss-single-selected").toggleClass("ss-open-below");

        currentEl.find(".arrow-down, .arrow-up").toggleClass("arrow-up").toggleClass("arrow-down");

        if (targetEl.hasClass("ss-option")) {
            const targetValHtml = targetEl.html();
            const targetVal = readNumberAttr(targetEl, "value");
            const ssDisabled = currentEl.find(".ss-disabled");
            ssDisabled.html(targetValHtml);
            ssDisabled.attr("value", targetVal);
        }

    }
    const classToSet = typeof className === "string" ? [className] : [...className];
    const classes = ["ss-67058 ss-main", ...classToSet];
    return (
        <div className={classes} style=""
             onClick={e => customSelectElementClickHandler(e)}
        >
            <div className="ss-single-selected">
                <span className="placeholder">
                    <span className="ss-disabled" value="0">Причина</span>
                </span>
                <span className="ss-deselect ss-hide"></span>
                <span className="ss-arrow">
                    <span className="arrow-up">
                    </span>
                </span>
            </div>
            <div className="ss-content">
                <div className="ss-search ss-hide">
                    <input
                        readonly=""
                        type="text"
                        placeholder="Искать"
                        tabindex="0"
                        aria-label="Искать"
                        autocapitalize="off"
                        autocomplete="off"
                        autocorrect="off"
                    />
                </div>
                <div className="ss-list">
                    {values.map((v, i) => <div className="ss-option" value={i + 1}>{v}</div>)}
                </div>
            </div>
        </div>

    );
}
